import { extendTheme } from "@chakra-ui/react"

// The interface font is Elza (Adobe Fonts kit in public/index.html). Without this, anything not inside a container
// that set it by hand (the question box, menus, modals, tooltips, buttons) fell back to Chakra's system font stack.
// Message text keeps Bitter, set where it is rendered.
const ELZA = '"Elza", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'

const theme = extendTheme({
  fonts: {
    body: ELZA,
    heading: ELZA,
  },
})

export default theme
